export const discordLink = 'https://discord.gg/qztDJ4NT';
export const githubOrgLink = 'https://github.com/metaloreai';
export const githubLink = 'https://github.com/metaloreai/gpthouseapi';
export const githubIssuesLink = 'https://github.com/metaloreai/gpthouseapi/issues';
export const githubReleasesLink = 'https://github.com/metaloreai/gpthouseapi/releases';
export const contactEmail = 'gpthouse.admin@metalore.ai';
export const contactEmailLink = `mailto:${contactEmail}`;
export const reservationLink = 'https://cal.com/metaloreai/30min';
export const trustAndSecurityLink = 'https://metalore.ai/trust-and-security';
export const pricingLink = 'https://metalore.ai/pricing';

/** Docs link */
export const envTagsFeatureLink = '/docs/references/tenants/#tenant-type';
export const organizationsFeatureLink = '/docs/recipes/organizations/';
export const organizationConfigGuideLink = '/docs/recipes/organizations/configuration/';
export const protectedAppLink = '/docs/recipes/protected-app/';
export const logtoThirdPartyGuideLink = '/docs/recipes/metaloreai-as-idp/';
export const logtoThirdPartyAppPermissionsLink =
  '/docs/recipes/metaloreai-as-idp/permissions-management/';
export const logtoThirdPartyAppBrandingLink =
  '/docs/recipes/metaloreai-as-idp/branding-customization/';
export const appSpecificBrandingLink =
  '/docs/recipes/customize-sie/match-your-brand/#app-specific-branding';
export const organizationLogosForExperienceLink =
  '/docs/recipes/customize-sie/match-your-brand/#organization-specific-logos';
export const signingKeysLink = '/docs/references/openid-connect/signing-keys-rotation/';
export const organizationTemplateLink =
  '/docs/recipes/organizations/understand-how-it-works/#organization-template';
export const organizationRoleLink =
  '/docs/recipes/organizations/understand-how-it-works/#organization-role';
export const organizationPermissionLink =
  '/docs/recipes/organizations/understand-how-it-works/#organization-permission';
export const profilePropertyReferenceLink = '/docs/references/users/#profile-1';
export const organizationJit = Object.freeze({
  enterpriseSso:
    '/docs/recipes/organizations/just-in-time-provisioning/#enterprise-sso-provisioning',
  emailDomain: '/docs/recipes/organizations/just-in-time-provisioning/#email-domain-provisioning',
});

export const addOnPricingExplanationLink =
  'https://blog.metalore.ai/pricing-add-on-a-simple-explanation/';
